import React from 'react';

import WordOnlinePage from '~/features/microsoft-integration/WordOnlinePage';

export default function Page(props) {
  return <WordOnlinePage {...props} />;
}
